import { sendWebsocketMessage } from '../../../../../App';

export function updateSavedAlertTradePlanConfiguration({
  configurationName,
  key,
  json,
}) {
  const msg = {
    messageType: 'updateSavedAlertTradePlanConfiguration',
    configurationName,
    key,
    alertJson:  json,
  };
  sendWebsocketMessage(msg);
}
